import * as JSPath from 'jspath';
export abstract class MigrationTransformBase<TOptions = any> {
	constructor(public options: TOptions) {}
	abstract get type(): string;
	abstract up(seed: object): object;
	abstract down(seed: object): object;
	getParentInstances(seed: object, parentJsPath?: string): object[]  {
		const parentInstances = parentJsPath ? JSPath.apply(parentJsPath, seed) : [seed];
		return parentInstances;
	}
}